export default __webpack_public_path__ + "static/media/home-creative-agency-img-08.c3612df4.jpg";